module.exports = __webpack_public_path__ + "img/wealth-title.7226f486.svg";